
import At from 'vue-at/src/At.vue';
import {getAtAndIndex, getPrecedingRange} from 'vue-at/src/util.js';
import {AxiosResponse} from 'axios';
import {AutoComplet} from '#/Search';
import vue from 'vue';

export default vue.extend({
  extends: At,

  name: 'CustomAtTextarea',

  methods: {
    handleInput(keep: string): void {
      // @ts-ignore
      if ((this.hasComposition as boolean)) return;
      // const el = this.$el.querySelector('textarea');
      // this.$emit('input', el?.value);
      // const text = el?.value.slice(0, el?.selectionEnd);
      const el = this.$el.querySelector('div[contenteditable="true"]');
      this.$emit('input', el?.textContent);
      const text = el?.textContent?.slice(0, el?.textContent?.length);
      if (text) {
        // @ts-ignore
        const {atItems, allowSpaces} = this;
        let show = true;
        const {at, index} = getAtAndIndex(text, atItems);
        if (index < 0) show = false;

        // authorise de commencer par un hashtag
        const prev = text[index - 1];
        if (prev && !/[^\w/]/.test(prev)) show = false;

        const chunk = text.slice(index + at.length, text.length);

        if (!allowSpaces && /\s/.test(chunk)) {
          show = false;
        }
        // chunk以空白字符开头不匹配 避免`@ `也匹配
        if (/^\s/.test(chunk)) show = false;

        if (!show) {
          // @ts-ignore
          this.closePanel();
        } else {
          // if (!keep) { // fixme: should be consistent with At.vue
          //   this.$emit('at', chunk)
          // }
          if (chunk.length > 1) {
            // @ts-ignore
            this.$axios.post('autocomplete/', {q: chunk})
                .then((response: AxiosResponse<AutoComplet>) => {
                  const matched = response.data.suggest.tagSuggest[0].options.map(r => r.text);
                  if (matched.length) {
                    // @ts-ignore
                    this.openPanel(matched, getPrecedingRange(), index, at, keep);
                  } else {
                    // @ts-ignore
                    this.closePanel();
                  }
                });
          } else {
            // @ts-ignore
            this.closePanel();
          }
        }
      } else {
        // @ts-ignore
        this.closePanel();
      }
    },
    handleKeyDown(e: KeyboardEvent): void {
      // @ts-ignore
      const {atwho} = this;
      if (atwho) {
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { // ↑/↓
          if (!(e.metaKey || e.ctrlKey)) {
            e.preventDefault();
            e.stopPropagation();
            // @ts-ignore
            this.selectByKeyboard(e);
          }
          return;
        }
        if (e.key === 'Enter' || e.key === 'Tab') { // enter or tab
          // @ts-ignore
          this.insertItem();
          e.preventDefault();
          e.stopPropagation();
          return;
        }
        if (e.key === 'Escape') { // esc
          // @ts-ignore
          this.closePanel();
          return;
        }
      }
      if (e.key === 'Backspace') {
        // @ts-ignore
        this.handleDelete(e);
      }
    },
  },
});
